module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_14-e86703e59661f3cb1476255c80391b0d.jpg";